import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';

const version = 'unversioned';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://a8cb40e1c9684a91b1134928b42d8301@sentry.io/1495644',
    maxBreadcrumbs: 10,
  });
  Sentry.configureScope(scope => {
    scope.setTag('app-version', version || 'not-defined');
  });

  window.onerror = function(msg, url, lineNo, columnNo, error) {
    if (
      msg.includes(
        'Warning: Material-UI: the component displayName is invalid. It needs to be a string.',
      )
    )
      return;
    Sentry.captureException(error, {});
    return false;
  };
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
